"use strict";
import a from "./index.es330.js";
const e = typeof URLSearchParams < "u" ? URLSearchParams : a;
export {
  e as default
};
//# sourceMappingURL=index.es407.js.map
